class AseguraGoAnalytics {

    constructor() {}


    getUtmSource() {
        return this.getCookie(window.MetricsManagerConstants?.METRICS_UTMS_SOURCE);
    }

    getUtmMedium() {
        return this.getCookie(window.MetricsManagerConstants?.METRICS_UTMS_MEDIUM);
    }

    getUtmCampaign() {
        return this.getCookie(window.MetricsManagerConstants?.METRICS_UTMS_CAMPAIGN);
    }

    getUtmContent() {
        return this.getCookie(window.MetricsManagerConstants?.METRICS_UTMS_CONTENT);
    }

    getUtmTerm() {
        return this.getCookie(window.MetricsManagerConstants?.METRICS_UTMS_TERM);
    }

    getUrlUtmsCalculated() {
        return this.getCookie(window.MetricsManagerConstants?.METRICS_URL_UTMS_CALCULATED) ?? window.location.href;
    }
    
    generateLeadId() {
        const random = Math.floor(Math.random() * 1000);
        const now = new Date();
        const day = now.getDay();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        const timestamp = now.getTime();
        return day + month + year + timestamp + random;
    }

    async generateHash(value) {
        const encoder = new TextEncoder();
        const data = encoder.encode(value);
        
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    
        return hashHex;
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }


    

}


window.AseguraGoAnalytics = AseguraGoAnalytics;